/* eslint-disable import/extensions */
import styled from 'styled-components';
import { Icon } from 'office-ui-fabric-react';
import theme from '../../asset/themes/defaultTheme';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 5%;
  box-sizing: border-box;
  font-family: ${theme.baseFontFamily};
  color: ${theme.brandBlack};
  background-color: ${theme.brandWhite};
  text-align: center;
`;

const ErrorIcon = styled(Icon)`
  font-size: ${theme.iconSizeLarge};
  color: ${theme.brandIconRed};
  margin-bottom: 16px;
`;

const Title = styled.h1`
  font-size: ${theme.fontSizeLarge};
  font-weight: ${theme.fontWeightBold};
  margin: 0 0 16px 0;
`;

const Details = styled.pre`
  max-width: 720px;
  width: 100%;
  margin: 0;
  padding: 16px;
  box-sizing: border-box;
  border: 1px solid ${theme.brandBorder};
  border-radius: 2px;
  background-color: ${theme.brandBackgroundGray};
  color: ${theme.brandExtraDarkGray};
  font-family: ${theme.baseFontFamily};
  font-size: ${theme.fontSizeLSmall};
  text-align: left;
  white-space: pre-wrap;
  word-break: break-word;
`;

export default {
  Container,
  ErrorIcon,
  Title,
  Details,
};
